import { Component, OnInit } from '@angular/core';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { gutil} from '../gutil';
import { Router} from "@angular/router";
import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {SessionService} from '../services/session.service';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.scss']
})
export class EditprofileComponent implements OnInit {

  public faUserCircle = faUserCircle;
    public user = {name:"",email:"", phone:"", gender:"", dob:"", emergencycontact:"",addressl1:"",city:"", state:"", nationality:"",father_name:"",mother_name:"", zipcode:"",adhaar_number:"", pan:"",occupation:"",off_email:"",off_address:"",off_name:"", off_city:"", off_state:"", off_zipcode:"", off_country:"",bank_ifsc:"",bank_account:""};
    public selectedCity: string;
    public genderSeluser: Array<any>;
    public citySel: Array<any>;
    public user_id: any;
    public minDOB:any;  
    public maxDOB:any; 
    public new_user:any;
    public form_msg:boolean = false;
    public form_submit_msg:any;
    public userimage:any;
    public form_success_msg: boolean = false;

  constructor(private http:HttpClient, private router: Router,private sessionservice : SessionService) {

    this.citySel = gutil.citySel;
    this.genderSeluser = gutil.genderSeluser;
   }

  ngOnInit(): void {
    this.new_user = gutil.user;
    this.user.name = this.new_user.name;
    this.user.phone = this.new_user.phone;
    this.user.email = this.new_user.email;
    this.user.emergencycontact = this.new_user.emergencycontact;
    this.user.father_name = this.new_user.father_name;
    this.user.mother_name = this.new_user.mother_name;
    this.user.nationality = this.new_user.nationality;
    this.user.addressl1 = this.new_user.addressl1;
    this.user.city = this.new_user.city;
    this.user.dob = this.new_user.dob;
    this.user.gender = this.new_user.gender;
    this.user.zipcode = this.new_user.zipcode;
    this.user.adhaar_number = this.new_user.adhaar_number;
    this.user.pan = this.new_user.pan;
    this.user.off_name = this.new_user.off_name;
    this.user.off_email = this.new_user.off_email;
    this.user.off_address = this.new_user.off_address;
    this.user.off_city = this.new_user.off_city;
    this.user.off_state = this.new_user.off_state;
    this.user.off_zipcode = this.new_user.off_zipcode;
    this.user.bank_account = this.new_user.bank_account;
    this.user.bank_ifsc = this.new_user.bank_ifsc;
    this.user.state = this.new_user.state;
    this.user.occupation = this.new_user.occupation;
    this.user.off_country = this.new_user.off_country;
    this.minDOB = moment().subtract(120, 'years').format("YYYY-MM-DD");
    this.maxDOB = moment().subtract(16, 'years').format("YYYY-MM-DD");
    
  }

  // form fields defined here
public onNameChange(value: any) {
  this.user.name = "";
  this.user.name = value;
}
public onChangeEmail(value: any) {
  this.user.email = "";
  this.user.email = value;
}
public onChangeFatherName(value: any) {
  this.user.father_name = "";
  this.user.father_name = value;
}
public onChangeMotherName(value: any) {
  this.user.mother_name = "";
  this.user.mother_name = value;
}
public onChangePhone(value:any) {
  this.user.phone = "";
  this.user.phone = value;
}
public onChangeEmergencyContact(value:any) {
  this.user.emergencycontact = "";
  this.user.emergencycontact = value;
}
public onChangeAddress(value: any) {
  this.user.addressl1 = "";
  this.user.addressl1 = value;
}
public onChangeState(value: any) {
  this.user.state = "";
  this.user.state = value;
}
public onChangeZipcode(value: any) {
  this.user.zipcode = "";
  this.user.zipcode = value;
}
public onChangeCity(value: any) {
  this.user.city = "";
  this.user.city = value;
}
public onChangeAdharNumber(value: any) {
  this.user.adhaar_number = "";
  this.user.adhaar_number = value;
}
public onChangePan(value: any) {
  this.user.pan = "";
  this.user.pan = value;
}
public onChangeOccupation(value: any) {
  this.user.occupation = "";
  this.user.occupation = value;
}
public onChangeNationality(value: any) {
  this.user.nationality = "";
  this.user.nationality = value;
}
public onGenderChange(value: any) {
  this.user.gender = "";
  this.user.gender = value;
}

public onDOBChange(value: any) {
  this.user.dob = ""
  this.user.dob = value;
}
// //Fields for Professional details defined here
public onChangeOffEmail(value: any) {
  this.user.off_email = "";
  this.user.off_email = value;
}
public onChangeOffName(value: any) {
  this.user.off_name = "";
  this.user.off_name = value;
}
public onChangeOffAddress(value: any) {
  this.user.off_address = "";
  this.user.off_address = value;
}
public onChangeOffCity(value: any) {
  this.user.off_city = "";
  this.user.off_city = value;
}
public onChangeOffState(value: any) {
  this.user.off_state = "";
  this.user.off_state = value;
}
public onChangeOffCountry(value: any) {
  this.user.off_country = "";
  this.user.off_country = value;
}
public onChangeOffZipcode(value: any) {
  this.user.off_zipcode = "";
  this.user.off_zipcode = value;
}
public onChangeBankIfsc(value: any) {
  this.user.bank_ifsc = "";
  this.user.bank_ifsc = value;
}
public onChangeBankAccount(value: any) {
  this.user.bank_account = "";
  this.user.bank_account = value;
}

public editProfile() {
  ///////////////////////////// Edit Profile for Tenant starts here / ///////////////////////////////////
  if(this.new_user.role == 1) {
    if(this.user.name!="" && this.user.email!="" && this.user.phone!="" && this.user.father_name!="" && 
        this.user.mother_name!="" && this.user.addressl1!="" && this.user.zipcode!="" && this.user.city!="" && 
        this.user.state!="" && this.user.gender!="" && this.user.occupation!="" && this.user.nationality!="" &&
        this.user.adhaar_number!="" && this.user.bank_account!="" && this.user.bank_ifsc!="" && this.user.dob!= ""&&
        this.user.off_name!="" && this.user.off_email!=""&& this.user.off_state!="" && this.user.off_city!="" &&
        this.user.off_address!="" && this.user.off_country!="" )
        {
            let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
            let options =  {headers: headers };
            let params = new URLSearchParams();
            let vdate:any;

            for (let key in this.user) {
                if(key == "dob" && this.user[key] != null){
                    vdate = new Date(this.user[key]);
                    params.append(key, gutil.getDate(vdate));
                }
                else if(key == "images" && this.userimage != undefined){
                    // this.onUserImageUpload(this.user_id);
                }
                else if(key == "images" || key == "imgUrl" || key == "updated_at" || key == "api_token"){
                    continue;
                }
                else{
                    params.append(key, this.user[key]);
                }
            }
            let paramsString = params.toString();
            this.http.post(gutil.devapiUrl + '/api/v1/user/edit/' + this.new_user.id + '?api_token=' + this.new_user.api_token,paramsString, options)    
                .subscribe((data:any) => {
                    this.form_success_msg = true;
                    this.form_submit_msg = "Thank You for submitting your form!"
                    this.http.get(gutil.devapiUrl + '/api/v1/user/info?api_token=' + this.new_user.api_token)
                        .subscribe((data:any) => {
                          
                          this.sessionservice.setUser(data.obj);
                          
                        })
                    this.clearNotfMsg();
                    this.completeEditProfile();
                });
            
        }
        else {
            this.form_msg = true;
            this.form_submit_msg = "All Fields Mandatory";
            this.clearNotfMsg();
        }
    }
  /////////////////////////////////// Edit profile for tenant ends here //////////////////////////////////

  ////////////////////////////////////Edit profile for owner starts here //////////////////////////////////
    else if(this.new_user.role == 2) {
      if(this.user.name!="" && this.user.email!="" && this.user.phone!="" && this.user.father_name!="" && 
      this.user.mother_name!="" && this.user.addressl1!="" && this.user.zipcode!="" && this.user.city!="" && 
      this.user.state!="" && this.user.gender!="" && this.user.occupation!="" && this.user.nationality!="" &&
      this.user.adhaar_number!="" && this.user.bank_account!="" && this.user.bank_ifsc!="" && this.user.dob!= ""&&
      this.user.off_name!="" && this.user.off_email!=""&& this.user.off_state!="" && this.user.off_city!="" &&
      this.user.off_address!="" && this.user.off_country!="" ) 
      {
          let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
          let options =  {headers: headers };
          let params = new URLSearchParams();
          let vdate:any;
          for (let key in this.user) {
            if(key == "dob" && this.user[key] != null){
                vdate = new Date(this.user[key]);
                params.append(key, gutil.getDate(vdate));
            }
            else if(key == "images" && this.userimage != undefined){
                // this.onUserImageUpload(this.user_id);
            }
            else if(key == "images" || key == "imgUrl" || key == "updated_at" || key == "api_token"){
                continue;
            }
            else{
                params.append(key, this.user[key]);
            }
        }
        let paramsString = params.toString();
        
            this.http.post(gutil.devapiUrl + '/api/v1/user/edit/' + this.new_user.id + '?api_token=' + this.new_user.api_token,paramsString, options)    
                .subscribe((data:any) => {
                    this.form_success_msg = true;
                    this.form_submit_msg = "Thank You for submitting your form!";
                    this.http.get(gutil.devapiUrl + '/api/v1/user/info?api_token=' + this.new_user.api_token)
                        .subscribe((data:any) => {
                          this.sessionservice.setUser(data.obj);
                          
                        })
                    this.clearNotfMsg();
                    setTimeout(() => {
                      this.router.navigate(['profile/owner']).then(() => {
                        window.location.reload();
                      })
                    }, 3000)
                });
      }
      else {
        this.form_msg = true;
        this.form_submit_msg = "All Fields Mandatory";
        this.clearNotfMsg();
    }
    }
    ///////////////////////////////// Edit profile for Owner ends here /////////////////////////////////
  }
  public clearNotfMsg() {
    setTimeout(() => {
        this.form_msg = false;
        this.form_success_msg = false;
    }, 3000)
  }
  public completeEditProfile() {
    setTimeout(() => {
      this.router.navigate(['profile/tenant']).then(() => {
        window.location.reload();
      })
    }, 3000)
    
  }
}
